var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "LBL0010127",
            columns: _vm.grid.columns,
            data: _vm.targetDept.checklist,
            gridHeight: _vm.gridHeight,
            merge: _vm.grid.merge,
            editable: _vm.editable && !_vm.disabled && _vm.checkAllFlag,
            isExcelDown: false,
            filtering: false,
            columnSetting: false,
          },
          on: { "table-data-change": _vm.tableDataChange },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  col.name === "customCol"
                    ? [
                        _c(_vm.imprComponent, {
                          tag: "component",
                          attrs: {
                            col: col,
                            props: props,
                            inputEditable:
                              _vm.editable && !_vm.disabled && _vm.checkAllFlag,
                            isImmShow: true,
                            requestContentsCols: _vm.requestContentsCols,
                            tableKey: "saiInternalActionChecklistResultId",
                            ibmTaskTypeCd: "ITT0000150",
                            ibmTaskUnderTypeCd: "ITTU000155",
                          },
                          on: { imprChange: _vm.imprChange },
                        }),
                      ]
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-chip" },
            _vm._l(_vm.options, function (dept, idx) {
              return _c(
                "q-chip",
                {
                  key: idx,
                  attrs: {
                    outline: "",
                    square: "",
                    removable: false,
                    color: dept.selected
                      ? dept.code == "ALL"
                        ? "orange"
                        : "primary"
                      : "grey-6",
                    "text-color": "white",
                    icon: "memory",
                    selected: dept.selected,
                    label: dept.codeName,
                  },
                  on: {
                    "update:selected": [
                      function ($event) {
                        return _vm.$set(dept, "selected", $event)
                      },
                      (state) => _vm.selectedDept(state, dept, idx),
                    ],
                  },
                  model: {
                    value: dept.check,
                    callback: function ($$v) {
                      _vm.$set(dept, "check", $$v)
                    },
                    expression: "dept.check",
                  },
                },
                [
                  dept.code != "ALL"
                    ? _c("q-tooltip", [_vm._v("심사자/부서")])
                    : _c("q-tooltip", [_vm._v("내부심사 체크리스트 결과")]),
                ],
                1
              )
            }),
            1
          ),
          _c(
            "template",
            { slot: "prefixContent" },
            [
              _c("font", { attrs: { color: "#C10015" } }, [
                _vm._v(" " + _vm._s(_vm.statusByDept) + " "),
              ]),
            ],
            1
          ),
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable && !_vm.disabled && _vm.checkAllFlag
                    ? _c("c-btn", {
                        attrs: {
                          isSubmit: _vm.isSave,
                          url: _vm.saveUrl,
                          param: _vm.targetDept.checklist,
                          mappingType: "PUT",
                          label: "LBLSAVE",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveChecklist,
                          btnCallback: _vm.saveChecklistCallback,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }